module.exports = __webpack_public_path__ + "static/media/17.4097c9c8.jpg";